import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { defineComponent, reactive, computed, openBlock, createElementBlock, normalizeClass, unref, createVNode, withCtx, Fragment, renderList, createBlock, createElementVNode, toDisplayString, withModifiers, createTextVNode } from 'vue';
import { useStyleConfig } from '../abstract';
import { Collapse, CollapsePanel, Tooltip } from 'ant-design-vue';
import { CaretRightFilled, QuestionCircleOutlined } from '@ant-design/icons-vue';
import LabelWrapper from '../label-wrapper/LabelWrapper.js';
import ColorPicker from '../color-picker/ColorPicker.js';
import useThemeStore from './store';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$2(value) {
  var type = _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject$2;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = _typeof(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = freeGlobal || freeSelf || Function('return this')();
var _root = root$2;
var root$1 = _root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function now$1() {
  return root$1.Date.now();
};
var now_1 = now$1;

/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
var _baseTrim = baseTrim$1;
var root = _root;

/** Built-in value references. */
var Symbol$2 = root.Symbol;
var _Symbol = Symbol$2;
var Symbol$1 = _Symbol;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var _Symbol2 = _Symbol,
  getRawTag = _getRawTag,
  objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol2 ? _Symbol2.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$1(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$1;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$1(value) {
  return value != null && _typeof(value) == 'object';
}
var isObjectLike_1 = isObjectLike$1;
var baseGetTag = _baseGetTag,
  isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
var isSymbol_1 = isSymbol$1;
var baseTrim = _baseTrim,
  isObject$1 = isObject_1,
  isSymbol = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$1;
var isObject = isObject_1,
  now = now_1,
  toNumber = toNumber_1;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
  nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(),
      isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce;
var _hoisted_1 = /*#__PURE__*/createElementVNode("br", null, null, -1 /* HOISTED */);
var _hoisted_2 = /*#__PURE__*/createElementVNode("div", null, "中性色", -1 /* HOISTED */);
var _hoisted_3 = /*#__PURE__*/createElementVNode("span", null, "基础文本色", -1 /* HOISTED */);
var _hoisted_4 = /*#__PURE__*/createElementVNode("span", null, "基础背景色", -1 /* HOISTED */);
var _hoisted_5 = /*#__PURE__*/createElementVNode("br", null, null, -1 /* HOISTED */);
var _sfc_main = /*#__PURE__*/defineComponent({
  __name: 'ColorEditor',
  setup: function setup(__props) {
    var _useStyleConfig = useStyleConfig('color-editor'),
      prefixCls = _useStyleConfig.prefixCls;
    var themeStore = useThemeStore();
    var theme = themeStore.theme;
    var setFunctionalColor = themeStore.setFunctionalColor,
      setPrimaryColor = themeStore.setPrimaryColor,
      setTextSeriesColors = themeStore.setTextSeriesColors,
      setBgSeriesColors = themeStore.setBgSeriesColors;
    var _setFunctionalColor = debounce_1(setFunctionalColor, 50);
    var _setPrimaryColor = debounce_1(setPrimaryColor, 50);
    var _setTextSeriesColors = debounce_1(setTextSeriesColors, 50);
    var _setBgSeriesColors = debounce_1(setBgSeriesColors, 50);
    var color = theme.color;
    var getColorName = function getColorName(name, colorKey) {
      var nameMap = {
        DEFAULT: '',
        bg: '背景色',
        'bg-hover': '背景色悬浮态',
        border: '边框色',
        'border-hover': '边框色悬浮态',
        hover: '悬浮态',
        active: '激活态',
        text: '文本色',
        'text-hover': '文本色悬浮态',
        'text-active': '文本色激活态'
      };
      return "".concat(name).concat(nameMap[colorKey]);
    };
    var colorGroups = reactive([{
      name: '主色',
      key: 'primary',
      colors: color.primary
    }, {
      name: '成功色',
      key: 'success',
      colors: color.success
    }, {
      name: '警告色',
      key: 'warning',
      colors: color.warning
    }, {
      name: '错误色',
      key: 'error',
      colors: color.error
    }, {
      name: '信息色',
      key: 'info',
      colors: color.info
    }]);
    function onColorChange(group, key, val) {
      if (group === 'primary') {
        _setPrimaryColor(_defineProperty({}, key, val));
      } else {
        _setFunctionalColor(group, _defineProperty({}, key, val));
      }
    }
    var middle = computed(function () {
      return theme.color.middle;
    });
    var middleColors = [{
      name: '文本',
      onChange: _setTextSeriesColors,
      children: [{
        name: '一级文本色',
        key: 'text-1'
      }, {
        name: '二级文本色',
        key: 'text-2'
      }, {
        name: '三级文本色',
        key: 'text-3'
      }, {
        name: '四级文本色',
        key: 'text-4'
      }]
    }, {
      name: '描边',
      onChange: _setTextSeriesColors,
      children: [{
        name: '一级边框色',
        key: 'border-1'
      }, {
        name: '二级边框色',
        key: 'border-2'
      }]
    }, {
      name: '填充',
      onChange: _setTextSeriesColors,
      children: [{
        name: '一级填充色',
        key: 'fill-1'
      }, {
        name: '二级填充色',
        key: 'fill-2'
      }, {
        name: '三级填充色',
        key: 'fill-3'
      }, {
        name: '四级填充色',
        key: 'fill-4'
      }]
    }, {
      name: '背景',
      onChange: _setBgSeriesColors,
      children: [{
        name: '布局背景色',
        key: 'bg-layout'
      }, {
        name: '组件容器背景色',
        key: 'bg-container'
      }, {
        name: '顶部背景色',
        key: 'bg-header'
      }, {
        name: '侧边背景色',
        key: 'bg-side'
      }, {
        name: '组件容器背景色',
        key: 'bg-container'
      }, {
        name: '浮层容器背景色',
        key: 'bg-popover'
      }, {
        name: '引起注意的背景色',
        key: 'bg-spotlight'
      }, {
        name: '蒙层背景色',
        key: 'bg-mask'
      }]
    }];
    return function (_ctx, _cache) {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass("".concat(unref(prefixCls)))
      }, [createVNode(unref(Collapse), {
        accordion: "",
        bordered: false,
        "expand-icon-position": "right"
      }, {
        expandIcon: withCtx(function (_ref) {
          var isActive = _ref.isActive;
          return [createVNode(unref(CaretRightFilled), {
            rotate: isActive ? 90 : 0
          }, null, 8 /* PROPS */, ["rotate"])];
        }),
        default: withCtx(function () {
          return [(openBlock(true), createElementBlock(Fragment, null, renderList(colorGroups, function (group, i) {
            return openBlock(), createBlock(unref(CollapsePanel), {
              key: i,
              class: "group"
            }, {
              header: withCtx(function () {
                return [createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-colors-header"))
                }, [createElementVNode("div", null, toDisplayString(group.name), 1 /* TEXT */), createVNode(ColorPicker, {
                  "onUpdate:modelValue": function onUpdateModelValue(val) {
                    return onColorChange(group.key, 'DEFAULT', val);
                  },
                  onClick: _cache[0] || (_cache[0] = withModifiers(function () {}, ["stop"])),
                  "model-value": group.colors.DEFAULT
                }, null, 8 /* PROPS */, ["onUpdate:modelValue", "model-value"])], 2 /* CLASS */)];
              }),

              default: withCtx(function () {
                return [createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-colors-desc"))
                }, toDisplayString('一些描述.....'), 3 /* TEXT, CLASS */), createVNode(LabelWrapper, {
                  layout: "vertical",
                  colon: false
                }, {
                  label: withCtx(function () {
                    return [createElementVNode("span", {
                      class: normalizeClass("".concat(unref(prefixCls), "-token-title"))
                    }, "Map Token", 2 /* CLASS */), createVNode(unref(Tooltip), {
                      title: "梯度变量（Map Token） 是基于 Seed 派生的梯度变量，我们精心设计的梯度变量模型具有良好的视觉设计语义，可在亮暗色模式切换时保证视觉梯度的一致性。"
                    }, {
                      default: withCtx(function () {
                        return [createVNode(unref(QuestionCircleOutlined), {
                          class: normalizeClass("".concat(unref(prefixCls), "-token-icon"))
                        }, null, 8 /* PROPS */, ["class"])];
                      }),
                      _: 1 /* STABLE */
                    }), _hoisted_1];
                  }),
                  default: withCtx(function () {
                    return [createElementVNode("div", {
                      class: normalizeClass("".concat(unref(prefixCls), "-colors-list"))
                    }, [(openBlock(true), createElementBlock(Fragment, null, renderList(Object.keys(group.colors).filter(function (item) {
                      return item !== 'DEFAULT';
                    }).map(function (item) {
                      return item;
                    }), function (color) {
                      return openBlock(), createElementBlock("div", {
                        key: color,
                        class: normalizeClass("".concat(unref(prefixCls), "-colors-list-item"))
                      }, [createElementVNode("div", {
                        class: normalizeClass("".concat(unref(prefixCls), "-colors-list-item-label"))
                      }, [createElementVNode("span", {
                        class: normalizeClass("".concat(unref(prefixCls), "-colors-list-item-label-name"))
                      }, toDisplayString(getColorName(group.name, color)), 3 /* TEXT, CLASS */), createElementVNode("span", {
                        class: normalizeClass("".concat(unref(prefixCls), "-colors-list-item-label-key"))
                      }, toDisplayString("color-".concat(group.key, "-").concat(color)), 3 /* TEXT, CLASS */)], 2 /* CLASS */), createVNode(ColorPicker, {
                        "onUpdate:modelValue": [function (val) {
                          return onColorChange(group.key, color, val);
                        }, function ($event) {
                          return group.colors[color] = $event;
                        }],
                        modelValue: group.colors[color]
                      }, null, 8 /* PROPS */, ["onUpdate:modelValue", "modelValue"])], 2 /* CLASS */);
                    }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)];
                  }),

                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */)];
              }),

              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */);
          }), 128 /* KEYED_FRAGMENT */)), createVNode(unref(CollapsePanel), null, {
            header: withCtx(function () {
              return [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-colors-middle-header"))
              }, [_hoisted_2, createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-colors-middle-group"))
              }, [_hoisted_3, createVNode(ColorPicker, {
                onClick: _cache[1] || (_cache[1] = withModifiers(function () {}, ["stop"])),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function (color) {
                  return unref(_setTextSeriesColors)({
                    'text-base': color
                  });
                }),
                "model-value": middle.value['text-base']
              }, null, 8 /* PROPS */, ["model-value"]), _hoisted_4, createVNode(ColorPicker, {
                onClick: _cache[3] || (_cache[3] = withModifiers(function () {}, ["stop"])),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = function (color) {
                  return unref(_setBgSeriesColors)({
                    'bg-base': color
                  });
                }),
                "model-value": middle.value['bg-base']
              }, null, 8 /* PROPS */, ["model-value"])], 2 /* CLASS */)], 2 /* CLASS */)];
            }),

            default: withCtx(function () {
              return [createVNode(LabelWrapper, {
                layout: "vertical",
                colon: false
              }, {
                label: withCtx(function () {
                  return [createElementVNode("span", {
                    class: normalizeClass("".concat(unref(prefixCls), "-token-title"))
                  }, "Map Token", 2 /* CLASS */), createVNode(unref(Tooltip), {
                    title: "梯度变量（Map Token） 是基于 Seed 派生的梯度变量，我们精心设计的梯度变量模型具有良好的视觉设计语义，可在亮暗色模式切换时保证视觉梯度的一致性。"
                  }, {
                    default: withCtx(function () {
                      return [createVNode(unref(QuestionCircleOutlined), {
                        class: normalizeClass("".concat(unref(prefixCls), "-token-icon"))
                      }, null, 8 /* PROPS */, ["class"])];
                    }),
                    _: 1 /* STABLE */
                  }), _hoisted_5];
                }),
                default: withCtx(function () {
                  return [createVNode(unref(Collapse), {
                    accordion: "",
                    class: normalizeClass("".concat(unref(prefixCls), "-middle-color-collapse")),
                    bordered: false,
                    "expand-icon-position": "right"
                  }, {
                    expandIcon: withCtx(function (_ref2) {
                      var isActive = _ref2.isActive;
                      return [createVNode(unref(CaretRightFilled), {
                        rotate: isActive ? 90 : 0
                      }, null, 8 /* PROPS */, ["rotate"])];
                    }),
                    default: withCtx(function () {
                      return [(openBlock(), createElementBlock(Fragment, null, renderList(middleColors, function (group) {
                        return createVNode(unref(CollapsePanel), null, {
                          header: withCtx(function () {
                            return [createElementVNode("div", {
                              class: normalizeClass("".concat(unref(prefixCls), "-middle-color-group"))
                            }, toDisplayString(group.name), 3 /* TEXT, CLASS */)];
                          }),

                          default: withCtx(function () {
                            return [createElementVNode("div", {
                              class: normalizeClass("".concat(unref(prefixCls), "-middle-color-list"))
                            }, [(openBlock(true), createElementBlock(Fragment, null, renderList(group.children, function (child) {
                              return openBlock(), createElementBlock("div", {
                                class: normalizeClass("".concat(unref(prefixCls), "-middle-color-list-item"))
                              }, [createElementVNode("div", {
                                class: normalizeClass("".concat(unref(prefixCls), "-middle-color-list-item-name"))
                              }, [createTextVNode(toDisplayString(child.name) + " ", 1 /* TEXT */), createElementVNode("span", {
                                class: normalizeClass("".concat(unref(prefixCls), "-middle-color-list-item-key"))
                              }, toDisplayString("color-".concat(child.key)), 3 /* TEXT, CLASS */)], 2 /* CLASS */), createVNode(ColorPicker, {
                                "onUpdate:modelValue": function onUpdateModelValue(val) {
                                  return group.onChange(_defineProperty({}, child.key, val));
                                },
                                "model-value": middle.value[child.key]
                              }, null, 8 /* PROPS */, ["onUpdate:modelValue", "model-value"])], 2 /* CLASS */);
                            }), 256 /* UNKEYED_FRAGMENT */))], 2 /* CLASS */)];
                          }),

                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */);
                      }), 64 /* STABLE_FRAGMENT */))];
                    }),

                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["class"])];
                }),
                _: 1 /* STABLE */
              })];
            }),

            _: 1 /* STABLE */
          })];
        }),

        _: 1 /* STABLE */
      })], 2 /* CLASS */);
    };
  }
});

var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var ColorEditor = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/theme-provider/ColorEditor.js"]]);
export { ColorEditor as default };